import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HttpRequestService } from '../_common/http-request.service';

@Injectable()
export class AutoTradeCoinConfigService {

    constructor(private http: HttpRequestService) {
    }

    getPairs(): Observable<any[]> {
        return this.http.get(`autotradecoinconfig/pairs`)
            .map(res => {
                return res.json()
            });
    }

    gets(parameters: any) {
        return this.http.get(`autotradecoinconfig/coins`, parameters)
            .map(res => {
                return res.json();
            })
    }

    get(coinId) {
        return this.http.get(`coinconfig/coin?id=${coinId}`)
            .map(res => {
                return res.json();
            })
    }

    active(model: any) {
        return this.http.put(`autotradecoinconfig/active`,
            model).map(res => {
                return res.json();
            });
    }

    activeAll(data) {
        return this.http.post(`autotradecoinconfig/activeAll`, data).map(res => {
            console.log(res);
            return res.json();
        });
    }

    edit(model: any) {
        return this.http.put(`autotradecoinconfig`,
            model).map(res => {
                console.log(res);
                return res.json();
            });
    }

    checkAllActive() {
        return this.http.get(`autotradecoinconfig/checkAllActive`).map(res => {
            return res.json();
        });
    }

    activeStatusOfUser() {
        return this.http.get(`autotradecoinconfig/getActiveStatus`).map(res => {
            return res;
        });
    }

    updateAutoTradeStatus(model: any) {
        return this.http.put(`autotradecoinconfig/updateAutoTradeStatus`,
            model).map(res => {
                return res.json();
            });
    }

    btcBalance() {
        return this.http.get(`autotradecoinconfig/btcBalance`).map(res => {
            console.log(res);
            return res;
        });
    }

}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_services/autotradecoinconfig.service.ts